export const TICKET_TYPES = ['Six Flags', 'Enchanted Parks'];

/** Always available on submit forms; managed separately from location CSV options */
export const GLOBAL_RESOLUTIONS = ['Other'];

export const RESERVED_OPTION_NAMES = ['Other'];

export const initialFormData = {
  guestName: '',
  guestEmail: '',
  ticketType: '',
  ticketId: '',
  guestConcern: '',
  resolution: '',
  resolutionOther: '',
  purchaseDate: '',
  purchaseTime: '',
  ccLast4: '',
  nameOnOrder: '',
  approvingSupervisorId: '',
};

export function buildFormDataFromPrefill(prefill) {
  if (!prefill) return { ...initialFormData };
  return {
    ...initialFormData,
    guestName: prefill.guestName || '',
    guestEmail: prefill.guestEmail || '',
    ticketType: prefill.ticketType || '',
    ticketId: prefill.ticketId || '',
  };
}

export function clearResolutionFields(prev, resolution) {
  const next = { ...prev, resolution };
  if (resolution !== 'Other') {
    next.resolutionOther = '';
  }
  if (resolution !== 'Refund Request') {
    next.purchaseDate = '';
    next.purchaseTime = '';
    next.ccLast4 = '';
    next.nameOnOrder = '';
    next.approvingSupervisorId = '';
  }
  return next;
}
